import { AppDispatch } from "../redux/store";
import { generateAIDescription } from "../redux/Actions/ClientActions";

interface GenerateDescriptionRequest {
  title: string;
  serviceType?: string;
  requestType?: string;
  equipmentType?: string;
  propertyType?: string;
}

interface GenerateDescriptionResponse {
  success: boolean;
  description?: string;
  error?: string;
}

class AIDescriptionService {
  async generateDescription(request: GenerateDescriptionRequest, dispatch: AppDispatch): Promise<GenerateDescriptionResponse> {
    try {
      const result = await dispatch(generateAIDescription({ data: request }));
      
      if (generateAIDescription.fulfilled.match(result)) {
        return {
          success: true,
          description: result.payload?.description || result.payload?.data?.description
        };
      } else {
        return {
          success: false,
          error: result.payload as string || "Failed to generate description"
        };
      }
    } catch (error) {
      console.error("Error generating AI description:", error);
      return {
        success: false,
        error: error instanceof Error ? error.message : "Failed to generate description"
      };
    }
  }
}

export const aiDescriptionService = new AIDescriptionService();
